import { APIService } from "services";

export const getVw_Nagar_Khanda = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllVw_Nagar_Khanda(pageNo,pageSize);
    }
    else{
        try {
            res = await searchVw_Nagar_Khanda(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const getAllVw_Nagar_Khanda = (pageNo,pageSize) => {
return APIService.api().get(`/vw_nagar_khanda/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const getOneVw_Nagar_Khanda = (nagar_khanda_id) => {
return APIService.api().get(`/vw_nagar_khanda/${nagar_khanda_id}`)
}
export const searchVw_Nagar_Khanda = (searchKey,pageNo,pageSize) => {
return APIService.api().get(`/vw_nagar_khanda/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
